if (!customElements.get('recipient-form')) {
  customElements.define(
    'recipient-form',
    class RecipientForm extends HTMLElement {
      constructor() {
        super();
        this.recipientFieldsLiveRegion = this.querySelector(`#Recipient-fields-live-region-${this.dataset.sectionId}`);
        this.checkboxInput = this.querySelector(`#Recipient-checkbox-${this.dataset.sectionId}`);
        this.checkboxInput.disabled = false;
        this.hiddenControlField = this.querySelector(`#Recipient-control-${this.dataset.sectionId}`);
        this.hiddenControlField.disabled = false;

        this.senderEmailInput = this.querySelector(`#Sender-email-${this.dataset.sectionId}`);
        this.senderNameInput = this.querySelector(`#Sender-name-${this.dataset.sectionId}`);

        this.emailInput = this.querySelector(`#Recipient-email-${this.dataset.sectionId}`);
        this.nameInput = this.querySelector(`#Recipient-name-${this.dataset.sectionId}`);
        this.messageInput = this.querySelector(`#Recipient-message-${this.dataset.sectionId}`);
        this.sendonInput = this.querySelector(`#Recipient-send-on-${this.dataset.sectionId}`);
        this.offsetProperty = this.querySelector(`#Recipient-timezone-offset-${this.dataset.sectionId}`);

        this.addToCartButton = document.querySelector('.product-form-buttons button[type="submit"]');

        if (this.offsetProperty) this.offsetProperty.value = new Date().getTimezoneOffset().toString();

        this.errorMessageWrapper = this.querySelector('.product-form__recipient-error-message-wrapper');
        this.errorMessageList = this.errorMessageWrapper?.querySelector('ul');
        this.errorMessage = this.errorMessageWrapper?.querySelector('.error-message');
        this.defaultErrorHeader = this.errorMessage?.innerText;
        this.currentProductVariantId = this.dataset.productVariantId;

        this.recipientFields = this.querySelector('.recipient-fields');

        this.previousRecipientValues = {
          email: '',
          name: '',
          message: '',
          sendon: '',
        };

        this.addEventListener('change', this.onChange.bind(this));

        this.previousCheckboxState = this.checkboxInput.checked;

        if (this.senderEmailInput) {
          this.senderEmailInput.addEventListener('input', this.handleSenderEmailChange.bind(this));
          this.senderEmailInput.addEventListener('keyup', this.handleSenderEmailChange.bind(this));
          this.senderEmailInput.addEventListener('keydown', this.handleSenderEmailChange.bind(this));
          this.senderEmailInput.addEventListener('paste', this.handleSenderEmailChange.bind(this));
          this.senderEmailInput.addEventListener('blur', this.handleSenderEmailChange.bind(this));
        }

        if (this.senderNameInput) {
          this.senderNameInput.addEventListener('input', this.handleSenderNameChange.bind(this));
          this.senderNameInput.addEventListener('keyup', this.handleSenderNameChange.bind(this));
          this.senderNameInput.addEventListener('keydown', this.handleSenderNameChange.bind(this));
          this.senderNameInput.addEventListener('paste', this.handleSenderNameChange.bind(this));
          this.senderNameInput.addEventListener('blur', this.handleSenderNameChange.bind(this));
        }

        this.addRecipientFieldListeners();
        this.onChange({ target: this.checkboxInput });
        this.validateAndToggleButton();
      }

      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;
      cartErrorUnsubscriber = undefined;

      connectedCallback() {
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          if (event.source === 'product-form' && event.productVariantId.toString() === this.currentProductVariantId) {
            this.resetRecipientForm();
          }
        });

        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (event.data.sectionId === this.dataset.sectionId) {
            this.currentProductVariantId = event.data.variant.id.toString();
          }
        });

        this.cartErrorUnsubscriber = subscribe(PUB_SUB_EVENTS.cartError, (event) => {
          if (event.source === 'product-form' && event.productVariantId.toString() === this.currentProductVariantId) {
            this.displayErrorMessage(event.message, event.errors);
          }
        });
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }

        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }

        if (this.cartErrorUnsubscriber) {
          this.cartErrorUnsubscriber();
        }
      }

      isValidEmail(email) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
      }

      areSenderFieldsValid() {
        const emailValid =
          this.senderEmailInput &&
          this.senderEmailInput.value.trim() !== '' &&
          this.isValidEmail(this.senderEmailInput.value.trim());

        const nameValid = this.senderNameInput && this.senderNameInput.value.trim() !== '';

        return emailValid && nameValid;
      }

      areRecipientFieldsValid() {
        if (this.checkboxInput.checked) {
          return true;
        }

        const emailValid =
          this.emailInput && this.emailInput.value.trim() !== '' && this.isValidEmail(this.emailInput.value.trim());
        const nameValid = this.nameInput && this.nameInput.value.trim() !== '';
        return emailValid && nameValid;
      }

      validateAndToggleButton() {
        if (!this.addToCartButton) return;
        const senderValid = this.areSenderFieldsValid();
        const recipientValid = this.areRecipientFieldsValid();
        const allValid = senderValid && recipientValid;

        if (allValid) {
          this.addToCartButton.disabled = false;
          this.addToCartButton.style.pointerEvents = 'auto';
          this.addToCartButton.style.opacity = '1';
        } else {
          this.addToCartButton.disabled = true;
          this.addToCartButton.style.pointerEvents = 'none';
          this.addToCartButton.style.opacity = '0.5';
        }
      }

      handleSenderEmailChange(event) {
        if (event && event.type === 'keydown') {
          setTimeout(() => {
            this.doEmailCopy();
            this.validateAndToggleButton();
          }, 10);
        } else {
          this.doEmailCopy();
          this.validateAndToggleButton();
        }
      }

      doEmailCopy() {
        if (this.checkboxInput.checked && this.emailInput) {
          this.emailInput.value = this.senderEmailInput.value;
        }
      }

      handleSenderNameChange(event) {
        if (event && event.type === 'keydown') {
          setTimeout(() => {
            this.doNameCopy();
            this.validateAndToggleButton();
          }, 10);
        } else {
          this.doNameCopy();
          this.validateAndToggleButton();
        }
      }

      doNameCopy() {
        if (this.checkboxInput.checked && this.nameInput) {
          this.nameInput.value = this.senderNameInput.value;
        }
      }

      storeRecipientValues() {
        this.previousRecipientValues = {
          email: this.emailInput?.value || '',
          name: this.nameInput?.value || '',
          message: this.messageInput?.value || '',
          sendon: this.sendonInput?.value || '',
        };
      }

      restoreRecipientValues() {
        if (this.emailInput) {
          this.emailInput.value = this.previousRecipientValues.email;
        }
        if (this.nameInput) {
          this.nameInput.value = this.previousRecipientValues.name;
        }
        if (this.messageInput) {
          this.messageInput.value = this.previousRecipientValues.message;
        }
        if (this.sendonInput) {
          this.sendonInput.value = this.previousRecipientValues.sendon;
        }
      }

      onChange(event) {
        if (event.target !== this.checkboxInput) {
          return;
        }

        if (this.checkboxInput.checked === this.previousCheckboxState) {
          return;
        }

        this.previousCheckboxState = this.checkboxInput.checked;

        if (this.checkboxInput.checked) {
          this.storeRecipientValues();
          this.hideRecipientFields();
          this.copyFromSenderToRecipient();
          if (this.messageInput) {
            this.messageInput.value = '';
          }
          if (this.emailInput) this.emailInput.removeAttribute('required');
          if (this.nameInput) this.nameInput.removeAttribute('required');
          this.clearErrorMessage();
          this.recipientFieldsLiveRegion.innerText =
            window.accessibilityStrings?.recipientFormCollapsed || 'Sending to yourself';
          this.hiddenControlField.disabled = true;
        } else {
          this.showRecipientFields();
          this.restoreRecipientValues();
          if (this.emailInput) this.emailInput.setAttribute('required', '');
          if (this.nameInput) this.nameInput.setAttribute('required', '');
          this.recipientFieldsLiveRegion.innerText =
            window.accessibilityStrings?.recipientFormExpanded || 'Sending to recipient';
          this.hiddenControlField.disabled = false;
        }

        this.validateAndToggleButton();
      }

      addRecipientFieldListeners() {
        if (this.emailInput && !this.emailInput.hasAttribute('data-validation-listener')) {
          this.emailInput.addEventListener('input', () => this.validateAndToggleButton());
          this.emailInput.addEventListener('blur', () => this.validateAndToggleButton());
          this.emailInput.setAttribute('data-validation-listener', 'true');
        }
        if (this.nameInput && !this.nameInput.hasAttribute('data-validation-listener')) {
          this.nameInput.addEventListener('input', () => this.validateAndToggleButton());
          this.nameInput.addEventListener('blur', () => this.validateAndToggleButton());
          this.nameInput.setAttribute('data-validation-listener', 'true');
        }
      }

      recipientInputFields() {
        return [this.emailInput, this.nameInput, this.messageInput, this.sendonInput].filter((field) => field);
      }

      allRecipientFields() {
        return [...this.recipientInputFields(), this.offsetProperty].filter((field) => field);
      }

      hideRecipientFields() {
        if (this.recipientFields) {
          this.recipientFields.style.display = 'none';
        }
      }

      showRecipientFields() {
        if (this.recipientFields) {
          this.recipientFields.style.display = 'block';
        }
      }

      copyFromSenderToRecipient() {
        if (this.senderEmailInput && this.emailInput) {
          this.emailInput.value = this.senderEmailInput.value;
        }

        if (this.senderNameInput && this.nameInput) {
          this.nameInput.value = this.senderNameInput.value;
        }
      }

      clearRecipientFields() {
        if (this.emailInput) {
          this.emailInput.value = '';
        }

        if (this.nameInput) {
          this.nameInput.value = '';
        }
      }

      clearRecipientInputFields() {
        this.recipientInputFields().forEach((field) => (field.value = ''));
        this.validateAndToggleButton();
      }

      displayErrorMessage(title, body) {
        this.clearErrorMessage();
        this.errorMessageWrapper.hidden = false;
        if (typeof body === 'object') {
          this.errorMessage.innerText = this.defaultErrorHeader;
          return Object.entries(body).forEach(([key, value]) => {
            const errorMessageId = `RecipientForm-${key}-error-${this.dataset.sectionId}`;
            const fieldSelector = `#Recipient-${key}-${this.dataset.sectionId}`;
            const message = `${value.join(', ')}`;
            const errorMessageElement = this.querySelector(`#${errorMessageId}`);
            const errorTextElement = errorMessageElement?.querySelector('.error-message');
            if (!errorTextElement) return;

            if (this.errorMessageList) {
              this.errorMessageList.appendChild(this.createErrorListItem(fieldSelector, message));
            }

            errorTextElement.innerText = `${message}.`;
            errorMessageElement.classList.remove('hidden');

            const inputElement = this[`${key}Input`];
            if (!inputElement) return;

            inputElement.setAttribute('aria-invalid', true);
            inputElement.setAttribute('aria-describedby', errorMessageId);
          });
        }

        this.errorMessage.innerText = body;
      }

      createErrorListItem(target, message) {
        const li = document.createElement('li');
        const a = document.createElement('a');
        a.setAttribute('href', target);
        a.innerText = message;
        li.appendChild(a);
        li.className = 'error-message';
        return li;
      }

      clearErrorMessage() {
        this.errorMessageWrapper.hidden = true;

        if (this.errorMessageList) this.errorMessageList.innerHTML = '';

        this.querySelectorAll('.recipient-fields .form__message').forEach((field) => {
          field.classList.add('hidden');
          const textField = field.querySelector('.error-message');
          if (textField) textField.innerText = '';
        });

        [this.emailInput, this.messageInput, this.nameInput, this.sendonInput].forEach((inputElement) => {
          if (inputElement) {
            inputElement.setAttribute('aria-invalid', false);
            inputElement.removeAttribute('aria-describedby');
          }
        });
      }

      resetRecipientForm() {
        if (this.checkboxInput.checked) {
          this.checkboxInput.checked = false;
          this.hiddenControlField.disabled = false;
          this.showRecipientFields();
          this.clearErrorMessage();
          this.validateAndToggleButton();
        }
      }
    },
  );
}
